import { render, staticRenderFns } from "./promo-banner-create.vue?vue&type=template&id=c07cec46&scoped=true"
import script from "./promo-banner-create.vue?vue&type=script&lang=js"
export * from "./promo-banner-create.vue?vue&type=script&lang=js"
import style0 from "./promo-banner-create.vue?vue&type=style&index=0&id=c07cec46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07cec46",
  null
  
)

export default component.exports